import React from "react";
import FormMain from "../components/Auth/FormMain";
const Auth = () => {
  return (
    <div>
      <div className="py-5">
        <FormMain />
      </div>
    </div>
  );
};

export default Auth;
